export default {
  fetched: false,
  idBy_id: {},
  idByCustomerCode: {},
  list: {},
  // shapes: {},
  storeHours: {},
  current: null,
};
